module.exports = "pegasus/assets/notes.png";